import { createWorkerHandler } from './createHandler';
import { getWixSDK } from '../utils/wix-sdk';

export function createWorkerHandlerForIframe(
  controllerConfig,
  { debug },
  flowAPI,
) {
  const WixSDK = getWixSDK();

  return createWorkerHandler(
    controllerConfig,
    {
      handleSetWidgetHeight: (height, width, options) =>
        WixSDK.setHeight(height, options),
      handleResizeWindow: WixSDK.resizeWindow,
      handleResizeComponent: WixSDK.resizeComponent,
      handleFitIntoView: async () => {
        const { rect, offsets } = await WixSDK.getBoundingRectAndOffsets();
        WixSDK.scrollTo(-rect.left, offsets.y, { scrollAnimation: true });
      },
      handleLogin: WixSDK.requestLogin,
      handleLogout: WixSDK.logOutCurrentMember,
      handleGoToPricingPlanPicker: (planIds = [], channelId) => {
        Wix.Utils.navigateToSection({
          sectionId: 'membership_plan_picker_tpa',
          appDefinitionId: '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
          queryParams: {
            planIds: planIds.join(','),
            biOptions: btoa(
              JSON.stringify({
                referralInfo: 'video',
                referralId: channelId,
              }),
            ),
          },
        });
      },
    },
    debug,
    flowAPI,
  );
}
